module.exports = __webpack_public_path__ + "static/assets/1ac03a53ecc806b652579f9f8da7c58a.mp3";